<template>
    <div v-if="isMobile" class="container sec-default-bg">
        <MobileHeaderBack closeText />

        <div class="mobile-account__container mt-15rem">
          <h2  class="signup-form__title">{{$t(title)}}</h2>
           <div class="change-password__form-group">
                <!--current password -->
                <div v-if="!isNeverSetPassword" class="form-group">
                    <label class="form-label">{{$t('CURRENT_PASSWORD')}}</label>
                    <div class="form-group__container">
                        <input class="form-control" :type="currentPassword.showPassword ? 'text' : 'password'" v-model="currentPassword.inputValue" minlength="8" maxlength="20" v-on:keyup="currentInputPasswordEvent" :placeholder="$t('ENTER_CURRENT_PASSWORD')">
                        <div class="display-flex-center form-icon pointer" @click="currentPassword.showPassword = !currentPassword.showPassword">
                            <!-- <img v-if="currentPassword.showPassword" src="../../../static/images/icons/icon_close_pwd.png">
                            <img v-else src="../../../static/images/icons/icon_show_pwd.png"> -->
                            
                            <SvgIcon v-if="currentPassword.showPassword" icon="sign.password.hide"></SvgIcon>
                            <SvgIcon v-else icon="sign.password.show"></SvgIcon>
                        </div>
                    </div>
                    <div class="form-tips">
                        <div v-if="currentPassword.isError" class="error">{{$t('FORGET_PASSWORD_ERR_MSG')}}</div>
                    </div>
                </div>
                <!--new password -->
                <div class="form-group mb-1rem">
                    <label class="form-label">{{$t('NEW_PASSWORD')}}</label>
                    <div class="form-tips top">
                        <div>{{$t('FORGET_PASSWORD_MSG')}}</div>
                    </div>
                    <div class="form-group__container">
                        <input class="form-control" :type="newPassword.showPassword ? 'text' : 'password'" v-model="newPassword.inputValue" minlength="8" maxlength="20" v-on:keyup="newInputPasswordEvent" :placeholder="$t('ENTER_NEW_PASSWORD')">
                        <div class="display-flex-center form-icon pointer" @click="newPassword.showPassword = !newPassword.showPassword">
                            
                            <SvgIcon v-if="newPassword.showPassword" icon="sign.password.hide"></SvgIcon>
                            <SvgIcon v-else icon="sign.password.show"></SvgIcon>
                        </div>
                    </div>
                    <div class="form-tips">
                        <div v-if="newPassword.isError" class="error">{{$t('FORGET_PASSWORD_ERR_MSG')}}</div>
                    </div>
                </div>
                <!-- confirm password -->
                <div class="form-group">
                        <label class="form-label">{{$t('CONFIRM_PASSWORD')}}</label>
                        <div class="form-group__container">
                            <input class="form-control" :type="confirmPassword.showPassword ? 'text' : 'password'" v-model="confirmPassword.inputValue" minlength="8" maxlength="20" v-on:keyup="confirmInputPasswordEvent" :placeholder="$t('RE_ENTER_NEW_PASSWORD')">
                            <div class="display-flex-center form-icon pointer" @click="confirmPassword.showPassword = !confirmPassword.showPassword">

                                <SvgIcon v-if="confirmPassword.showPassword" icon="sign.password.hide"></SvgIcon>
                                <SvgIcon v-else icon="sign.password.show"></SvgIcon>
                            </div>
                        </div>
                        <div class="form-tips">
                            <div v-if="confirmPassword.isError" class="error">{{$t('RETYPE_YOUR_PASSWORD')}}</div>
                        </div>
                </div>
            </div>
            <!-- save profile -->
            <div class="display-flex-fe" style="padding-bottom: 5rem;">
                <button class="btn btn-submit btn-aspn-primary enable w-100" :class="{'disable disabled': !isSaveBtnEnable}" @click="handleSavePassword">{{$t('CONFIRM')}}</button>
            </div> 
        </div>
    </div>
    <div class="password-container" v-else>
        <div class="container">
            <div class="account-content__title">{{ $t('ACCOUNT') }}</div>
            <div class="form-container">
                <div class="account-content__subtitle display-flex-sb">
                    <div class="">{{$t(title)}}</div>
                    <!-- save profile -->
                    <div class="">
                        <button class="btn btn-aspn-primary" :class="{'disabled':!isSaveBtnEnable}" @click="handleSavePassword">{{$t('SAVE')}}</button>
                    </div>
                </div>
                <div class="account-content__wrapper">
                    <div>
                        <div class="change-password__form-group">
                            <!--current password -->
                            <div v-if="!isNeverSetPassword" class="form-group">
                                <label class="form-label">{{$t('CURRENT_PASSWORD')}}</label>
                                <div class="form-group__container">
                                    <input class="form-control" :type="currentPassword.showPassword ? 'text' : 'password'" v-model="currentPassword.inputValue" minlength="8" maxlength="20" v-on:keyup="currentInputPasswordEvent" :placeholder="$t('ENTER_CURRENT_PASSWORD')">
                                    <div class="display-flex-center form-icon pointer" @click="currentPassword.showPassword = !currentPassword.showPassword">
                                        <!-- <img v-if="currentPassword.showPassword" src="../../../static/images/icons/icon_close_pwd.png">
                                        <img v-else src="../../../static/images/icons/icon_show_pwd.png"> -->
                                        
                                        <SvgIcon v-if="currentPassword.showPassword" icon="sign.password.hide"></SvgIcon>
                                        <SvgIcon v-else icon="sign.password.show"></SvgIcon>
                                    </div>
                                </div>
                                <div class="form-tips">
                                    <div v-if="currentPassword.isError" class="error">{{$t('FORGET_PASSWORD_ERR_MSG')}}</div>
                                </div>
                            </div>
                            <!--new password -->
                            <div class="form-group">
                                <label class="form-label">{{$t('NEW_PASSWORD')}}</label>
                                <div class="form-tips top">
                                    <div >{{$t('FORGET_PASSWORD_MSG')}}</div>
                                </div>
                                <div class="form-group__container">
                                    <input class="form-control" :type="newPassword.showPassword ? 'text' : 'password'" v-model="newPassword.inputValue" minlength="8" maxlength="20" v-on:keyup="newInputPasswordEvent" :placeholder="$t('ENTER_NEW_PASSWORD')">
                                    <div class="display-flex-center form-icon pointer" @click="newPassword.showPassword = !newPassword.showPassword">
                                        <!-- <img v-if="newPassword.showPassword" src="../../../static/images/icons/icon_close_pwd.png">
                                        <img v-else src="../../../static/images/icons/icon_show_pwd.png"> -->
                                        <SvgIcon v-if="newPassword.showPassword" icon="sign.password.hide"></SvgIcon>
                                        <SvgIcon v-else icon="sign.password.show"></SvgIcon>
                                    </div>
                                </div>
                                <div class="form-tips">
                                    <div v-if="newPassword.isError" class="error">{{$t('FORGET_PASSWORD_ERR_MSG')}}</div>
                                </div>
                            </div>
                            <!-- confirm password -->
                            <div class="form-group">
                                <label class="form-label">{{$t('CONFIRM_PASSWORD')}}</label>
                                <div class="form-group__container">
                                    <input class="form-control" :type="confirmPassword.showPassword ? 'text' : 'password'" v-model="confirmPassword.inputValue" minlength="8" maxlength="20" v-on:keyup="confirmInputPasswordEvent" :placeholder="$t('RE_ENTER_NEW_PASSWORD')">
                                    <div class="display-flex-center form-icon pointer" @click="confirmPassword.showPassword = !confirmPassword.showPassword">
                                        <!-- <img v-if="confirmPassword.showPassword" src="../../../static/images/icons/icon_close_pwd.png">
                                        <img v-else src="../../../static/images/icons/icon_show_pwd.png"> -->
                                        <SvgIcon v-if="confirmPassword.showPassword" icon="sign.password.hide"></SvgIcon>
                                        <SvgIcon v-else icon="sign.password.show"></SvgIcon>
                                    </div>
                                </div>
                                <div class="form-tips">
                                    <div v-if="confirmPassword.isError" class="error">{{$t('RETYPE_YOUR_PASSWORD')}}</div>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>
    
            <div class="form-container">
                <div>
                    <DeleteAccount :isComponent="true"></DeleteAccount>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import MobileHeaderBack from '@/components/mobile/HeaderBack.vue'
import AccountIndex from '@/views/account/Index.vue'
import DeleteAccount from './DeleteAccount.vue'

import {mapGetters,mapActions} from 'vuex'
import { bottom } from '@popperjs/core'
export default {
    components: {
        AccountIndex,
        MobileHeaderBack,
        DeleteAccount
    },
    data() {
        return {
            isSaveBtnEnable: false,
            isNeverSetPassword: true,

            currentPassword: {
                inputValue: '',
                showPassword: false,
                isError: false,  
            },
            newPassword: {
                inputValue: '',
                showPassword: false,
                isError: false,
            },
            confirmPassword: {
                inputValue: '',
                showPassword: false,
                isError: false,
            },
        }
    },
    created() {
      
    },

    beforeUnmount() {
        window.removeEventListener('keydown', this.listenKeypressEvent)
    },
    mounted() {
        window.addEventListener('keydown', this.listenKeypressEvent);
        this.init();
    },
     computed: {
        ...mapGetters([
            'isMobile',
            'currentLocale',
            'isLogin',
            "userInfo",
            "currentLanguageObj"
        ]),
        title() {
            if(this.isNeverSetPassword) {
                return 'ADD_PASSWORD'
            }
            return 'CHANGE_PASSWORD'
        }
    },
    methods: {
         ...mapActions([
            "getRetrieveUserInfo",
            "postUpdatePassword",
            "setUserData",
            "postSetPassword",
            "toastrChangeEvent",
             "commonVerifyLogin"
        ]), 

        init() {
             this.commonVerifyLogin();
             
            //otp (never set new password before)
            if (this.userInfo.loginMethod === 1) {
                this.isNeverSetPassword = true;
            } else {
                this.isNeverSetPassword = false;              
            }
        },

       // get user info
        async getRetrieveUserInfoData() {
            let params = {
                token: this.userInfo.token,
                timeZone:this.$tools.getCurrentTimeZone()
            }
            const result = await this.getRetrieveUserInfo(params);

            this.setUserData(result.result.data);
            this.init();
        },

        //current password input event
        currentInputPasswordEvent() {
            let minLength = 8;
            let maxLength = 20;
            
            if (this.$tools.noSymbolVerification(this.currentPassword.inputValue) && this.currentPassword.inputValue.length >= minLength && this.currentPassword.inputValue.length <= maxLength) {
                this.currentPassword.isError = false;
            } else {
                this.currentPassword.isError = true;
            }

            this.verifyAllInput();
        },

        //new password input event
        newInputPasswordEvent() {
            let minLength = 8;
            let maxLength = 20;
            
            if (this.$tools.noSymbolVerification(this.newPassword.inputValue) && this.newPassword.inputValue.length >= minLength && this.newPassword.inputValue.length <= maxLength) {
                this.newPassword.isError = false;
            } else {
                this.newPassword.isError = true;
            }

            if (this.confirmPassword.inputValue !== this.newPassword.inputValue) {
               if (this.confirmPassword.inputValue.length > 0) {
                    this.confirmPassword.isError = true;
                }
            } else {
                this.confirmPassword.isError = false;
            }
            this.verifyAllInput();
        },

        //confirm password input event
        confirmInputPasswordEvent() {
            if (this.confirmPassword.inputValue !== this.newPassword.inputValue) {
                this.confirmPassword.isError = true;
            } else {
                this.confirmPassword.isError = false;
            }

            if (this.confirmPassword.inputValue.length === 0) {
                 this.confirmPassword.isError = true;
            }
            
            this.verifyAllInput();
        },

        //verify all input value
        verifyAllInput() {
            if (this.isNeverSetPassword) {
                this.currentPassword.inputValue = "";
                if (this.newPassword.inputValue.length > 0 && this.confirmPassword.inputValue.length > 0) {
                    if (this.newPassword.inputValue === this.confirmPassword.inputValue) {
                        if (this.newPassword.isError || this.confirmPassword.isError) {
                            this.isSaveBtnEnable = false;
                        } else {
                            this.isSaveBtnEnable = true;
                        }
                    
                    } else {
                        this.isSaveBtnEnable = false;
                    }
                } else {
                     this.isSaveBtnEnable = false;
                }
            } else {
                if (this.currentPassword.inputValue.length > 0 && this.newPassword.inputValue.length > 0 && this.confirmPassword.inputValue.length > 0) {
                    if (this.currentPassword.isError || this.newPassword.isError || this.confirmPassword.isError) {
                        this.isSaveBtnEnable = false;
                    } else {
                        this.isSaveBtnEnable = true;
                    }
                } else {
                    this.isSaveBtnEnable = false;
                }
            }          
        },

        // update password
        async handleSavePassword() {
            let result;
            let toastMsg = "PASSWORD_CHANGED_SUCUESSFULLY";

            if (this.currentPassword.isError || this.newPassword.isError || this.confirmPassword.isError || !this.isSaveBtnEnable) {
                return
            }
           
            let params = {
                oldPassword: this.currentPassword.inputValue,
                newPassword: this.newPassword.inputValue,               
                confirmNewPassword: this.confirmPassword.inputValue,
                token: this.userInfo.token,
            }
            if (this.isNeverSetPassword) {
                let params = {
                    confirmPassword: this.confirmPassword.inputValue,
                    password: this.newPassword.inputValue,
                    token: this.userInfo.token,
                }
                result = await this.postSetPassword(params);
                toastMsg = "NEW_PASSWORD_SAVE_SUCUESSFULLY";
                
                this.getRetrieveUserInfoData();
            } else {
                result = await this.postUpdatePassword(params);
            }

            let paramsToastr={
                    isOpen:true,
                    msg:'',
                    type:''       
                }
            if (result.result.businessCode === 0) {
                paramsToastr.msg = toastMsg;
                //this.$root.toastrMsg = toastMsg;
        

                if (this.isNeverSetPassword) {
                    this.isNeverSetPassword = false;
                    this.title = this.$route.meta.name;
                }
                
                this.resetAllInput();
                this.verifyAllInput();
                
            } else {
                paramsToastr.msg = result.result.message;
                 this.$root.toastrMsg = result.result.message;
                 paramsToastr.type= 'info';
                 //this.$root.toastrType = 'info'
                   
            }
        
            this.toastrChangeEvent(paramsToastr);
            //this.$root.$refs.toastrRef.handleOpen(); 
        },

        resetAllInput() {
            this.currentPassword.inputValue = "";
            this.newPassword.inputValue = "";
            this.confirmPassword.inputValue = "";
        },

        listenKeypressEvent(e) {
            if (e.key === "Enter") {
               this.handleSavePassword();
            } 
        },
        changePasswordType(item) {
            switch(item.showPassword) {
                case 'text':
                    item.showPassword = 'password' ;
                case 'password':
                    item.showPassword = 'text'
            }
                
        }
    },

}
</script>

<style>
.change-password__form-group{
    margin-bottom: 2.5625rem;
}
</style>

<style scoped>
.container {
    max-width: 800px;
    padding: 32px 0;
}
.form-tips.top {
    margin-top: 0;
    margin-bottom: 8px;
    color: var(--color-text-default-secondary);
}
.account-content__title {
    font-size: 32px;
	line-height: 120%;
    color: var(--color-text-default-default);
	letter-spacing: -0.64px;
    font-family: var(--weight-600);
    max-width: 736px;
    margin: auto;
    margin-bottom: 32px;
}
.account-content__subtitle {
    font-size: 20px;
    color: var(--color-text-default-default);
    font-family: var(--weight-700);
    margin-bottom: 32px;
}
.form-container {
    background-color: var(--color-background-default-secondary);
    padding: 32px;
    border-radius: 16px;
    margin-bottom: 16px;
}
.form-group {
  margin-bottom: 24px;
}
.account-content__wrapper {
    max-width: 368px;
}
.password-container {
    background-color: var(--color-background-default-default);
}
@media(max-width: 768px) {  /* for test */
.account-content__wrapper {
    max-width: unset;
}
.container {
    max-width: unset;
    padding: 0;
}
}
</style>